<header
  class="header navbar navbar-expand-lg bg-white border-light navbar-ys"
  [ngClass]="{
    'sticky-md-top animate__animated animate__fadeInDown animate__faster': sticky
  }"
  style="z-index: 11"
>
  <div class="container px-3">
    <a class="navbar-brand pe-3 text-dark d-flex align-items-center" [routerLink]="['/']"
      ><img
        src="/assets/icons/device-fav.svg"
        alt="Yo Scenario logo"
        height="32"
        class="me-2"
      /> Scenario Library
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarCollapse"
      aria-title="Expand menu"
      aria-expanded="false" (click)="toggleCollapsed()"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <nav id="navbarCollapse"  [ngClass]="{'collapse': collapsed, 'navbar-collapse': true}">
      <hr class="d-lg-none mt-3 mb-2" />
      <div class="me-auto"></div>
      <!--ul class="navbar-nav me-auto">
        <li class="nav-item">
          <a href="/home#features" class="nav-link ">Features</a>
        </li>
        <li class="nav-item">
          <a href="/home#examples" class="nav-link">Examples</a>
        </li>
        <li class="nav-item">
          <a href="/home#services" class="nav-link">Services</a>
        </li>
        <li class="nav-item">
          <a [routerLink]="['/pricing']" class="nav-link">Pricing</a>
        </li>
        
      </ul-->
      <ng-container *ngIf="!userData">
        <a
          [routerLink]="['/login']"
          class="btn btn-cancel rounded-pill me-2 rounded d-flex align-items-center"
        >
          <i class="bx bx-log-in me-2"></i> Sign in
        </a>
        <a
          [routerLink]="['/register']"
          class="btn btn-dark me-2 rounded-pill d-flex align-items-center"
        >
          <i class="bx bx-user me-2"></i> Sign up
          <i class="ms-2 bx bx-right-arrow-alt"></i>
        </a>
      </ng-container>
      <ng-container *ngIf="userData">
        <a
          [routerLink]="['/dashboard']"
          class="btn btn-dark me-2 rounded-pill d-flex align-items-center"
        >
          <i class="bx bx-user me-2"></i> Dashboard
          <i class="ms-2 bx bx-right-arrow-alt"></i>
        </a>
      </ng-container>
    </nav>
  </div>
</header>
